import { makeStyles } from '@material-ui/core/styles';

export const useInfoHelpModalStyles = makeStyles((theme) => ({
    dialogPaper: {
        overflow: 'hidden',
        borderRadius: 10,
        border: '1px solid var(--card-border, #e5e7eb)',
        boxShadow: '0 12px 40px rgba(15, 23, 42, 0.12), 0 4px 12px rgba(15, 23, 42, 0.06)',
    },
    dialogTitle: {
        margin: 0,
        padding: theme.spacing(2, 2.5),
        borderBottom: '1px solid #e8eaef',
        background: 'linear-gradient(180deg, #fafbfc 0%, #f4f6f8 100%)',
    },
    dialogTitleInner: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: theme.spacing(1.25),
        minWidth: 0,
    },
    titleIcon: {
        color: theme.palette.primary.main,
        opacity: 0.9,
        flexShrink: 0,
        marginTop: 2,
        fontSize: 22,
    },
    titleText: {
        fontSize: 16,
        fontWeight: 600,
        lineHeight: 1.35,
        letterSpacing: '-0.01em',
        color: '#1a1d26',
        minWidth: 0,
    },
    dialogContent: {
        padding: theme.spacing(2, 2.5, 2.5),
    },
    textBody: {
        whiteSpace: 'pre-wrap',
        fontSize: 14,
        lineHeight: 1.55,
        color: '#2B2C35',
        margin: 0,
    },
    tableSurface: {
        borderRadius: 8,
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        backgroundColor: '#fff',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.85)',
    },
    tableRoot: {
        tableLayout: 'fixed',
        width: '100%',
        borderCollapse: 'collapse',
        '& tbody tr:nth-of-type(even)': {
            backgroundColor: 'rgba(249, 250, 252, 0.85)',
        },
        '& tbody tr:hover': {
            backgroundColor: 'rgba(241, 245, 249, 0.95)',
        },
    },
    tableHeadCell: {
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.02em',
        textTransform: 'none',
        color: '#374151',
        backgroundColor: '#f1f3f6',
        borderBottom: '1px solid #e2e5eb',
        borderRight: '1px solid #eceef2',
        verticalAlign: 'top',
        maxWidth: 0,
        padding: '10px 12px',
        '&:last-child': {
            borderRight: 'none',
        },
    },
    tableBodyCell: {
        fontSize: 13,
        lineHeight: 1.45,
        color: '#2B2C35',
        verticalAlign: 'top',
        borderBottom: '1px solid #eef0f4',
        borderRight: '1px solid #f0f2f5',
        maxWidth: 0,
        padding: '10px 12px',
        '&:last-child': {
            borderRight: 'none',
        },
    },
    /** Single-line ellipsis wrapper (tooltips show full text) */
    ellipsisOneLine: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'block',
        minWidth: 0,
        width: '100%',
    },
    /** Bullet lists: clip height + per-line ellipsis */
    cellBulletList: {
        margin: 0,
        paddingLeft: 16,
        maxHeight: '4.6em',
        overflow: 'hidden',
        fontSize: 13,
        lineHeight: 1.4,
        '& li': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
    },
    tooltipPopper: {
        maxWidth: 480,
    },
    backdrop: {
        backgroundColor: 'rgba(15, 23, 42, 0.42)',
    },
}));
